import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Box, Button, Grid, TextField} from 'views/components';
import {Translate, translate} from 'views/module';

const DeclineCancelRequest = (props) => {
  const {closeModel, event, onDeclineEvent} = props;

  const [reason, setReason] = React.useState('');
  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = async (e) => {
    setIsSaving(true);
    await onDeclineEvent(
        event.eventRn,
        'requestCancel',
        reason,
        () => {
          closeModel(true);
          setIsSaving(false);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="sm" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='schedule.eventDetail.DeclineDialogTitle.Title'/>
      </DialogTitle>
      <DialogContent >
        <Grid item xs={12}
          sx={{
            m: 1,
          }}
        >
          <TextField
            placeholder={translate('schedule.eventDetail.Reason.ReasonForReschedule')}
            label={translate('schedule.eventDetail.Reason.Reason')}
            value={reason}
            onChange={(e) => setReason(e)}
            fullWidth
            multiline
          />
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving}
        >
          <Translate expression="generic.Save" />
        </Button>
      </Box>
    </Dialog>
  );
};

DeclineCancelRequest.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onDeclineEvent: PropTypes.func.isRequired,
};

export default DeclineCancelRequest;
